import { __rest } from "tslib";
import React, { useContext } from 'react';
import s from './picture.module.css';
import WideContent from './wide-content';
import { Picture } from '../../picture/';
import { context } from '../utils';
var ModalPicture = function ModalPicture(_a) {
  var _a$header = _a.header,
    header = _a$header === void 0 ? true : _a$header,
    _a$footer = _a.footer,
    footer = _a$footer === void 0 ? false : _a$footer,
    picture = __rest(_a, ["header", "footer"]);
  var _useContext = useContext(context),
    dataTest = _useContext.dataTest;
  return React.createElement(WideContent, {
    header: header,
    footer: footer
  }, React.createElement("div", {
    className: s.wrapper,
    "data-test": dataTest && "".concat(dataTest, "-picture")
  }, React.createElement(Picture, Object.assign({}, picture, {
    className: s.image
  }))));
};
export default ModalPicture;